import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-info-anticipos',
  templateUrl: './info-anticipos.component.html',
  styleUrls: ['./info-anticipos.component.scss'],
})
export class InfoAnticiposComponent implements OnInit {
  public TotalCuotaNeta = 0
  public TotalCuotaRegular = 0;
  public TotalDescuento = 0;
  @Input() PoderPagarAnticipos: boolean = false;
  @Input() set Info(val){
    for(let i in val){
      console.clear()
      console.log(val)
      val[i].MesesAnticipar=0
      val[i].checked = true
      this.TotalCuotaRegular+=Number(val[i].CuotaRegular)
      this.TotalCuotaNeta+=Number(val[i].CuotaNeta)
      this.TotalDescuento+=Number(val[i].Descuento)
    }
    this.Datos = val
  };
  Datos: Array<any>=[]
  Familia;
  MesesAnticipar = 0
  constructor(private popover: PopoverController, private utilidades: UtilidadesService) { }

  ngOnInit() {

    let familias = JSON.parse(atob(localStorage.getItem(btoa("Familias"))))
    this.utilidades.Depuracion(familias, "console", "")
    let b64carrito_familia = localStorage.getItem(btoa("CarritoFamilia"))
    if(b64carrito_familia){
      for(let i of familias){
        if(Number(i.CodigoFamilia)==Number(atob(b64carrito_familia))){
          this.Familia = i
        }
      }
    }else{
      setTimeout(() => {
        this.popover.dismiss()
      }, 150);
    }
  }

  VerificarMayor0(ev){
      if(ev.target.value<=0){
        ev.target.value=0
      }

  }


  Aumentar(val){
    if(this.MesesAnticipar + val >= 0){
      this.MesesAnticipar += val
    }
  }

  Cerrar(dato){
    if(dato){
      this.popover.dismiss(this.TotalCuotaNeta*this.MesesAnticipar)
    }else{
      this.popover.dismiss(dato)
    }
  }
}
